export default __webpack_public_path__ + "static/media/jenkins.b0b715f7.svg";